// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".position-tracker-fast{background-color:rgba(3,133,161,.2);font-weight:400}.night-theme-template .position-tracker-fast{color:#fff}.position-tracker-slow{background-color:rgba(4,175,92,.2);font-weight:400}.night-theme-template .position-tracker-slow{color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
